import React from 'react';
// import { Spin, Space } from 'antd';
import {CLOSE_REWARD_SVG } from '../staticTypes'



const Header = (props) => {
	const {points, onClick, launcherFlag} = props;
	const closeReward = () => {
		onClick(!launcherFlag)
	}
	
	return (
		<div className="panel-header-container expanded-header compact-banner collapsed" tabIndex="-1">
			<div className="panel-fixed-header">
				<button className="close-btn panel-header-icon" aria-label="Close" onClick={closeReward}>
					{CLOSE_REWARD_SVG}
				</button>
			</div>
			<div className="panel-expanded-header background-gradient">
				<div className="banner-content">
					{
						points > -1 ?
							<div className="login-wantdo">
								<div className="header-secondary heading text-truncate">Your Point</div>
								<div className="header-primary display text-truncate" style={{ fontSize: 32 + 'px' }}>{points}</div>
							</div>
							:
							<div className="no-login-wantdo">
								<div className="header-secondary heading text-truncate">
									Welcome to
						</div>
								<div className="header-primary display text-truncate" style={{ fontSize: 32 + 'px' }}>
									Wantdo
						</div>
							</div>
					}


				</div>
			</div>
		</div>
	)
}

export default Header;